import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Title from '../../../../asset/svg/header-title.svg';
import { TextElem } from '../../../../common/text';
import { FONT_FAMILY_ENUM } from '../../../../common/text/constant';
import { i18n } from '../../../../lib/lang';
import { MamaButton } from '../promo-button';
import { PATH, menuItems } from './constant';

export const Header: React.FC<{}> = ({ }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleRedirect = (path: PATH) => {
    if (path === PATH.RULES) {
      window.open(i18n.t('MAMA.RULE.BUTTON_HREF'), '_blank');
      return;
    }

    history.push(path);
    setMenuOpen(false);

    setTimeout(() => {
      if (path === PATH.SUPPORT) {
        document.getElementById('help')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    }, 100);
  };

  const goToRules = () => {
    handleRedirect(PATH.HOME);
    setTimeout(() => document.getElementById('faq')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    }), 100);
  };

  const mainHref = i18n.t('MAMA.MENU.ICON_HREF');

  return (
    <Wrapper>
      <Container>
        <LinkStyled target="_blank" href={mainHref}>
          <TitleImg src={Title} />
        </LinkStyled>
        <Menu>
          {menuItems.map((item) => (
            <React.Fragment key={item.path}>
              <TextContainer onClick={() => handleRedirect(item.path)}>
                <TextElemStyled
                  active={currentPath === item.path}
                  color="black"
                  type={item.bold ? 'bold' : 'semi-bold'}
                  size="label"
                  tid={item.label}
                  fontFamily={FONT_FAMILY_ENUM.RF_DEWI}
                />
              </TextContainer>
            </React.Fragment>
          ))}
        </Menu>
        <DesktopOnly><MamaButton color='pink' tid='MAMA.MENU.ABOUT' onClick={goToRules} /></DesktopOnly>
        <HamburgerButton onClick={() => setMenuOpen((v) => !v)}>
          <HamburgerLine />
          <HamburgerLine />
          <HamburgerLine />
        </HamburgerButton>
      </Container>

      {menuOpen && <Overlay onClick={() => setMenuOpen(false)} />}
      <MobileDrawer open={menuOpen}>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.path}>
            <TextContainer onClick={() => handleRedirect(item.path)}>
              <TextElemStyled
                active={currentPath === item.path}
                color="black"
                type={item.bold ? 'bold' : 'semi-bold'}
                size="default"
                tid={item.label}
                fontFamily={FONT_FAMILY_ENUM.RF_DEWI}
              />
            </TextContainer>
            {index < menuItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        <DrawerButtonWrapper>
          <MamaButton color='pink' tid='MAMA.MENU.ABOUT' onClick={goToRules} />
        </DrawerButtonWrapper>
      </MobileDrawer>
    </Wrapper>
  );
};

const LinkStyled = styled.a`
  transition: 0.3s opacity ease;

  :hover {
    opacity: 0.7;
  }
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 20px;
  z-index: 3;

  @media screen and (max-width: 520px) {
    padding: 25px 20px;
  }
`;

const TextElemStyled = styled(TextElem) <{ active?: boolean }>`
  color: ${({ active }) => active && 'rgb(250, 42, 205)'};
  transition: opacity 0.3s ease;
  cursor: pointer;
  font-style: normal;
  padding: 11px 0;
  letter-spacing: -0.03em;
  overflow-wrap: break-word;
  text-align: center;

  :hover {
    opacity: 0.7;
  }

  @media screen and (max-width: 1100px) {
    font-size: 14px;
    padding: 9px 0;
  }

  @media screen and (max-width: 407px) {
    font-size: 12px;
  }
`;

const Divider = styled.div`
  width: 1px;
  background-color: rgba(54, 24, 85, 0.1);
`;

const Menu = styled.div`
  display: flex;
  padding: 6px 49px;
  gap: 36px;
  border-radius: 15px;
  background-color: white;

  justify-content: space-between;
  box-shadow: 7px 7px 0 rgba(45, 42, 38, 0.2);

  @media screen and (max-width: 1117px) {
    display: none;
  }
`;

const MenuMobile = styled(Menu)`
  display: none;
  box-shadow: 3px 3px 0 rgba(45, 42, 38, 0.2);

  @media screen and (max-width: 1117px) {
    display: flex;
    padding: 0 20px;
  }

  @media screen and (max-width: 500px) {
    gap: 8px;
  }

  @media screen and (max-width: 330px) {
    gap: 4px;
  }
`;

const LogoImg = styled.img`
  width: 98px;
  height: auto;

  @media screen and (min-width: 520px) and (max-width: 1074px) {
    width: 74.5px;
  }

  @media screen and (max-width: 567px) {
    width: 51px;
  }

  @media screen and (max-width: 358px) {
    width: 40px;
  }
`;

const TitleImg = styled.img`
  width: 275px;
  height: auto;

  @media screen and (min-width: 520px) and (max-width: 1074px) {
    width: 194px;
  }

  @media screen and (max-width: 567px) {
    width: 188px;
  }

  @media screen and (max-width: 358px) {
    width: 188px;
  }
`;


const Container = styled.header`
  display: flex;
  width: 100%;
  max-width: 1200px;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  @media screen and (max-width: 1117px) {
    /* justify-content: center; */
    gap: 40px;
  }

  @media screen and (max-width: 410px) {
    justify-content: space-between;
    gap: unset;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: white;
  border: none;
  cursor: pointer;
  box-shadow: 3px 3px 0 rgba(45, 42, 38, 0.15);
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.75;
  }

  @media screen and (max-width: 1117px) {
    display: flex;
  }
`;

const HamburgerLine = styled.span`
  display: block;
  width: 20px;
  height: 2.5px;
  border-radius: 2px;
  background-color: #333;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10;
`;

const DesktopOnly = styled.div`
  @media screen and (max-width: 1117px) {
    display: none;
  }
`;

const MobileDrawer = styled.div<{ open: boolean }>`
  position: absolute;
  top: calc(100% - 15px);
  right: 20px;
  transform: translateX(-50%) ${({ open }) => (open ? 'translateY(0)' : 'translateY(-8px)')};
  display: none;
  flex-direction: column;
  background: white;
  border-radius: 15px;
  box-shadow: 3px 3px 0 rgba(45, 42, 38, 0.2);
  padding: 8px 20px 16px;
  width: 100%;
  max-width: 300px;
  z-index: 11;

  transition: opacity 0.2s ease, transform 0.2s ease;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-8px)')};
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};

  @media screen and (max-width: 1117px) {
    display: flex;
    justify-content: end;
  }
`;

const DrawerButtonWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
`;